const ONLY_LETTERS = /[^a-zA-Z]/g

/**
 * Converting firstName and lastName to initials
 * e.g. Bob Ross -> BR
 * @param {String} firstName
 * @param {String} lastName
 * @return {String} Uppercase initials
 */
const getIntials = (firstName = '', lastName = '') => {
  const initials = firstName.charAt(0) + lastName.charAt(0)
  return initials.toUpperCase()
}

type User = {
  firstName?: string
  lastName?: string
}

export const getUserInitials = (user: User) => {
  return getIntials(user.firstName, user.lastName)
}

type AdminUser = {
  user: User
}

export const getAdminUserInitials = (adminUser: AdminUser) => {
  return getUserInitials(adminUser.user)
}

export const getOptimisticInitials = (text: string) => {
  const trimmedText = text?.trim()

  if (!trimmedText?.length) return ''

  if (trimmedText.split(' ').length === 1) {
    if (trimmedText.length === 1) {
      return trimmedText.toUpperCase() // handle single letter words
    }
    return `${trimmedText[0].toUpperCase()}${trimmedText[1].toUpperCase()}` // handle single words
  }

  const [a, b] = trimmedText
    .split(' ')
    .map((word) => word.replace(ONLY_LETTERS, ''))
    .map((word) => (word.length > 0 ? word[0].trim() : ''))
    .map((letter) => letter?.toUpperCase())
    .filter((char) => !!char)

  return `${a || ''}${b || ''}`
}

export default getIntials
